import BaseMapper from '../../BaseMapper';
import { store } from '../../../store';
import { LANGUAGES } from '../../../constants/defaultValues';

const OutrightSeasonMapper = (data, context) => {
    const reduxStore = store.getState();

    const { locale } = reduxStore.settings;

    data.seasonName = data.names[locale] || data.names[LANGUAGES.eng];

    return data;
};

export default OutrightSeasonMapper;
